import React, { useEffect, useState } from "react";
import { getGallery } from "../Service/Api";
import Slider from "react-slick";
import LazyLoad from "react-lazyload";

const HomeEvent = () => {
    const [data, setData] = useState([]);

    useEffect(() => {
        const getData = async () => {
            try {
                const response = await getGallery();
                setData(response);
            } catch (error) {
                console.error("Failed to fetch gallery data:", error);
            }
        };
        getData();
    }, []);

    const settings = {
        autoplay: true,
        infinite: true,
        autoplaySpeed: 2000,
        speed: 1000,
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 0,
        arrows: false,
        adaptiveHeight: true,
        responsive: [
            { breakpoint: 1300, settings: { slidesToShow: 2 } },
            { breakpoint: 992, settings: { slidesToShow: 2 } },
            { breakpoint: 767, settings: { slidesToShow: 2 } },
            { breakpoint: 600, settings: { slidesToShow: 1 } },
        ],
    };

    const formatDate = (isoDate) => {
        if (!isoDate) return "";
        const options = { year: "numeric", month: "short", day: "numeric" };
        return new Date(isoDate).toLocaleDateString(undefined, options);
    };

    const filteredData = data.filter((item) => item.category === "Activity");

    const renderStaticFallback = () => (
        <>
            <div className="item">
                <div className="canvas_blk">
                    <div className="canvas_blkimg">
                        <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/canvas1.png"
                            className="img-fluid"
                            alt="Art Activity"
                        />
                    </div>
                    <div className="canvas_blkdesc">
                        <div className="canvas_blktitle">
                            <p>Art Activity</p>
                        </div>
                    </div>
                </div>
            </div>

      
        </>
    );

    return (
        <div className="row">
            <div className="eventbg">
                <Slider {...settings}>
                    {filteredData.length > 0
                        ? filteredData.map((item, index) => (
                            <div className="item" key={index}>
                                <div className="canvas_blk">
                                    <div className="canvas_blkimg">
                                        <LazyLoad>
                                            <img
                                                src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments?.[0] || "SFXH/public/images/canvas2.png"}`}
                                                className="img-fluid"
                                                alt={item.title || "Event Image"}
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/canvas2.png";
                                                }}
                                            />
                                        </LazyLoad>
                                    </div>
                                    <div className="canvas_blkdesc">
                                        <div className="canvas_blktitle">
                                            <p>{item.title}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                        : renderStaticFallback()}
                </Slider>
            </div>
        </div>
    );
};

export default HomeEvent;
